/**
 * Registro data-driven de ESTACIONES DE CRAFTEO (objetos del mundo).
 *
 * Una estación es un objeto estático clickeable: al hacerle click estando a ≤2 tiles se abre
 * la ventana de crafteo filtrada por su `stationType` (ver shared/data/recipes.ts). Sumar una
 * estación = sumar una entrada acá (nombre + sprite + skill de acento para la UI).
 *
 * Primera estación: banco de carpintería. Futuras: horno (mena→lingote) y fragua/yunque
 * (lingote→equipo) de herrería, olla/fogón de cocina.
 *
 * Ver docs/CRAFTING_SYSTEM.md.
 */

import type { SkillId } from '../types/skills';

export interface CraftingStationMeta {
  /** ID del tipo de estación (debe matchear el `stationType` de las recetas). */
  stationType: string;
  /** Nombre visible (español). */
  name: string;
  /** Skill de procesamiento asociada (acento de color en la UI). */
  skill: SkillId;
  /** Sprite/ícono de la estación (placeholder hasta tener arte → cae a noicon). */
  icon: string;
}

export const CRAFTING_STATIONS: Record<string, CraftingStationMeta> = {
  carpentry_bench: {
    stationType: 'carpentry_bench',
    name: 'Banco de Carpintería',
    skill: 'skill_carpentry',
    icon: 'station_carpentry',
  },
  cooking_fire: {
    stationType: 'cooking_fire',
    name: 'Fogón',
    skill: 'skill_cooking',
    icon: 'station_cooking',
  },
};

export function getCraftingStationMeta(stationType: string): CraftingStationMeta | undefined {
  return CRAFTING_STATIONS[stationType];
}

/**
 * Colocación fija de una estación en el mapa (patrón de ResourceNodePlacement).
 * Determinística: las estaciones están siempre en el mismo lugar.
 */
export interface CraftingStationPlacement {
  stationType: string;
  x: number;
  y: number;
}

// Estaciones de debug de map1 (Fase A): un banco de carpintería al sur de la ciudad, cerca de
// las colecciones de skill, para testear el crafteo de cañas. Editor-placed queda para después.
export const MAP1_CRAFTING_STATIONS: CraftingStationPlacement[] = [
  { stationType: 'carpentry_bench', x: 618, y: 660 },
  { stationType: 'cooking_fire', x: 616, y: 660 },
];

export function getCraftingStationPlacementsForMap(mapId: string): CraftingStationPlacement[] {
  if (mapId === 'map1') return [...MAP1_CRAFTING_STATIONS];
  return [];
}
